import Card from "./Card";
import PasswordGate from "./PasswordGate";
import "./styles.css";

export default function App() {
    return (
        <PasswordGate>
            <div className="App">
                <Card />
            </div>
        </PasswordGate>
    );
}
